import { lottieAnimations } from '@backrs_ui/common-ui';

import { Box, SxProps, Theme } from '@mui/material';
import Lottie from 'lottie-react';

import { TestBoosterBanner } from './TestBoosterBanner';
import { boosterPageSx } from '../satActBooster.styles';

/** Full-page loading state while the submission read is in flight. */
export const BoosterLoading = () => (
  <Box sx={boosterPageSx}>
    <TestBoosterBanner />
    <Box sx={loaderSx}>
      <Lottie animationData={lottieAnimations.dotsDotting} loop />
    </Box>
  </Box>
);

const loaderSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: backrs.spacing['spacing-8xl'],
});
